import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider,TextField, Grid, Typography, Box } from "@mui/material"

import {getPoStruct, setData} from './PoStruct'
import { updateTextValue, handleSubmit,updateValue,updateSelectedValue} from '../../core/js/FormUtils'
import {createAPI, updateAPI, getAPI, updateEditableAPI} from './PoAPI';
import {CoreContext} from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {validMobileNumberEntry, validNameEntry, validEmailEntry} from '../../core/js/FormValidation';

import {getPathVariable} from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch,useSelector } from 'react-redux';
import { updatePoObj,addPoObj, setShowEditForPo} from 'store/slice/PharmaSlice';
import EditorderActionModal from '../pharmaorder/action/editorder/EditorderActionModal';
import UploadPoActionImpl from './action/uploadPo/UploadPoActionImpl';




export default function PoEditFormImplFormOnly(){
    const dispatch = useDispatch();
    const { setNotification, lastURL } = React.useContext(CoreContext);
    const [formValues, setFormValues] = useState(getPoStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const {poDashboard, pharmaorderDashboard} = useSelector((state)=>state.pharmaslice);
    const [poId, setPoId] = useState(poDashboard.selectedId);
    const {editorderModalOpen} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);
    

    useEffect(() => {
        if (poId!==-1) {
            if (dataLoaded) return;
            getAPI(poId, loadForm);

        }
        else {
           // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['partyid']:{
              ...formValues['partyid'],
              value:pharmaorderDashboard.pharmaorderObj.partyid
            },
            ['partyname']:{
                ...formValues['partyname'],
                value:pharmaorderDashboard.pharmaorderObj.partyname
              },
            ['businessid']:{
            ...formValues['businessid'],
            value:0
            },
          })

    },[]);

    const loadForm = (data)=>{
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value ) 
            return "yes"
        else 
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value ==="yes") 
            return true
        else 
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        updateTextValue(formValues, setFormValues,e);
    }

    const handleNameChange = (e) =>{
        setShowError(false);
        
       if (validNameEntry(e))
        updateTextValue(formValues, setFormValues,e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);
        
       if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);
        
       if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }

    const createSuccessCallback = (obj) =>{
        dispatch(addPoObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForPo(false));
    }
    const updateSuccessCallback = (obj) =>{
        dispatch(updatePoObj(obj));
        setNotification('Record with id['+poId+'] has been updated successfully !!!');
        dispatch(setShowEditForPo(false));
        
    }
    const failuerCallback = (errorMsg) => {
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const onSubmit=(e)=>{
        handleSubmit(e,poId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, createAPI, updateAPI);
    }
    const setDate= (fieldName, value) =>{
        var date = new Date(value); 
        var dateStrArray = date.toLocaleDateString().split('/');
        var dateStr = dateStrArray[2]+"-"+ dateStrArray[1]+"-"+dateStrArray[0]+"T00:00:00.000+00:00";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form  noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError? <Alert severity="error">{errorMsg}</Alert>: ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{overflowY: "scroll", maxHeight:440}}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>Po {poId===-1?'Add':'Edit'}</Typography>
                                <Divider/>
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center"> 
                                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.podate.label}
                            fieldName={formValues.podate.name}
                            defaultValue={formValues.podate.value}
                            errStr={formValues.podate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.partyid.placeholder}
                                    required={formValues.partyid.required}
                                    label={formValues.partyid.label}
                                    name={formValues.partyid.name}
                                    value={formValues.partyid.value}
                                    onChange={handleTextChange}
                                    error={formValues.partyid.error}
                                    helpertext={formValues.partyid.error && formValues.partyid.errorMessage}
                                    sx={{paddingBottom:2, width:'100%', display:'none'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.partyname.placeholder}
                                    required={formValues.partyname.required}
                                    label={formValues.partyname.label}
                                    name={formValues.partyname.name}
                                    value={formValues.partyname.value}
                                    onChange={handleTextChange}
                                    error={formValues.partyname.error}
                                    helpertext={formValues.partyname.error && formValues.partyname.errorMessage}
                                    sx={{paddingBottom:2, width:'100%', display:'none'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.povalue.placeholder}
                                    required={formValues.povalue.required}
                                    label={formValues.povalue.label}
                                    name={formValues.povalue.name}
                                    value={formValues.povalue.value}
                                    onChange={handleTextChange}
                                    error={formValues.povalue.error}
                                    helpertext={formValues.povalue.error && formValues.povalue.errorMessage}
                                    sx={{paddingBottom:2, width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.ordervalue.placeholder}
                                    required={formValues.ordervalue.required}
                                    label={formValues.ordervalue.label}
                                    name={formValues.ordervalue.name}
                                    value={formValues.ordervalue.value}
                                    onChange={handleTextChange}
                                    error={formValues.ordervalue.error}
                                    helpertext={formValues.ordervalue.error && formValues.ordervalue.errorMessage}
                                    sx={{paddingBottom:2, width:'100%', display:'none'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.popath.placeholder}
                                    required={formValues.popath.required}
                                    label={formValues.popath.label}
                                    name={formValues.popath.name}
                                    value={formValues.popath.value}
                                    onChange={handleTextChange}
                                    error={formValues.popath.error}
                                    helpertext={formValues.popath.error && formValues.popath.errorMessage}
                                    sx={{paddingBottom:2, width:'100%', display:'none'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.businessid.placeholder}
                                    required={formValues.businessid.required}
                                    label={formValues.businessid.label}
                                    name={formValues.businessid.name}
                                    value={formValues.businessid.value}
                                    onChange={handleTextChange}
                                    error={formValues.businessid.error}
                                    helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                    sx={{paddingBottom:2, width:'100%', display:'none'}}
                                />
                            </Grid>
                         
                                </Grid>
                            :<></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider/>
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                    <Button variant="outlined" type="submit" >{poId===-1?'Add':'Save'}</Button>&nbsp;&nbsp;&nbsp;
                    <Button variant="outlined" onClick={()=>{dispatch(setShowEditForPo(false));}}>Close</Button>
                </Grid>
            </Grid>
        </form>
    );
};